import { Injectable } from '@angular/core';
import { User } from '../dg_core/header/header.component';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/internal/operators/map';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GenericApprovalService {
  constructor(private http: HttpClient) {}
  methodForLoginDetails() {
    //fetch empid
    return this.http
      .get(/* '/admin/my-profile' */ `/admin/user-login-dtls`)
      .pipe(
        map(
          (response: { data: User; [key: string]: unknown }) => response?.data
        )
      );
  }
  createNewProcess(res: any) {
    return this.http.post('/gen-case-mgmnt/generic-cases', res).pipe(
      map((response: any) => response),
      catchError((error) => throwError(error))
    );
  }
  getPreviewData(docId: number | string) {
    return this.http.get(`/dms/file-content?mpgId=${docId}`).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }

  updateGeneric(res: any) {
    return this.http.put('/gen-case-mgmnt/update-generic-dtls', res).pipe(
      map((response: any) => response),
      catchError((error) => throwError(error))
    );
  }
  generateGenericNote(res: any) {
    return this.http.post('/gen-case-mgmnt/apprvl-note', res).pipe(
      map((response: any) => response),
      catchError((error) => throwError(error))
    );
  }
  getDocumentData(docId: number | string) {
    let params = new HttpParams();
    params = params.append('caseId', docId);
    return this.http
      .get(`/gen-case-mgmnt/generic-case-details`, { params: params })
      .pipe(
        map((response: any) => response?.data),
        catchError((error) => throwError(error))
      );
  }
  returnToHierarchy(postData: any) {
    return this.http.post('/workflow/workflow-operation', postData).pipe(
      map((response: any) => response),
      catchError((error) => throwError(error))
    );
  }
}
